import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "index";
import { apiRequest } from "utils/api";
import { CURRENT_USER_QUERY_KEY } from "../queries/use-current-user-query";

export const useUpdateUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      email,
      first_name,
      last_name,
    }: {
      email: string;
      first_name: string;
      last_name: string;
    }) => {
      await supabase.auth.updateUser({
        email,
        data: {
          first_name,
          last_name,
        },
      });
      await apiRequest("/supabase/users/update", {
        values: {
          first_name,
          last_name,
          email,
        },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CURRENT_USER_QUERY_KEY });
    },
  });
};
